import _classCallCheck from "/vercel/workpath0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/workpath0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/vercel/workpath0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/vercel/workpath0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";
import _taggedTemplateLiteral from "/vercel/workpath0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n:host {\n  opacity: 0;\n}\n:host(.wired-rendered) {\n  opacity: 1;\n}\n#overlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  pointer-events: none;\n}\nsvg {\n  display: block;\n}\npath {\n  stroke: currentColor;\n  stroke-width: 0.7;\n  fill: transparent;\n}\n.hidden {\n  display: none !important;\n}\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

import { LitElement, query, css } from 'lit-element';
export var BaseCSS = css(_templateObject());
export var WiredBase = /*#__PURE__*/function (_LitElement) {
  _inherits(WiredBase, _LitElement);

  var _super = _createSuper(WiredBase);

  function WiredBase() {
    var _this;

    _classCallCheck(this, WiredBase);

    _this = _super.apply(this, arguments);
    _this.lastSize = [0, 0];
    _this.seed = Math.floor(Math.random() * Math.pow(2, 31));
    return _this;
  }

  _createClass(WiredBase, [{
    key: "updated",
    value: function updated(_changed) {
      this.wiredRender();
    }
  }, {
    key: "wiredRender",
    value: function wiredRender() {
      var force = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (this.svg) {
        var size = this.canvasSize();

        if (!force && size[0] === this.lastSize[0] && size[1] === this.lastSize[1]) {
          return;
        }

        while (this.svg.hasChildNodes()) {
          this.svg.removeChild(this.svg.lastChild);
        }

        this.svg.setAttribute('width', "".concat(size[0]));
        this.svg.setAttribute('height', "".concat(size[1]));
        this.draw(this.svg, size);
        this.lastSize = size;
        this.classList.add('wired-rendered');
      }
    }
  }]);

  return WiredBase;
}(LitElement);

__decorate([query('svg'), __metadata("design:type", SVGSVGElement)], WiredBase.prototype, "svg", void 0);

export function fire(element, name, detail) {
  var bubbles = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
  var composed = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;

  if (name) {
    var init = {
      bubbles: typeof bubbles === 'boolean' ? bubbles : true,
      composed: typeof composed === 'boolean' ? composed : true
    };

    if (detail) {
      init.detail = detail;
    }

    element.dispatchEvent(new CustomEvent(name, init));
  }
}
export function randomSeed() {
  return Math.floor(Math.random() * Math.pow(2, 31));
}